var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloseCircle = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0Zm3.077 4.175a.27.27 0 0 0-.383 0L8 6.87 5.306 4.175a.27.27 0 0 0-.383 0l-.844.845a.27.27 0 0 0 0 .382l2.694 2.694L4.08 10.79a.27.27 0 0 0 0 .383l.844.844a.27.27 0 0 0 .383 0L8 9.323l2.694 2.694a.27.27 0 0 0 .383 0l.844-.844a.27.27 0 0 0 0-.383L9.227 8.096l2.694-2.694a.27.27 0 0 0 0-.382Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloseCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/close-circle.2b5416237828032d0245e84d918367b6.svg";